import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

import { parentSelector } from '../../selectors/parentSelector';
import { ApplicationState } from '../../types';

import { Entities } from './types';

export const getEntities = createSelector<ApplicationState, ApplicationState, Entities>(
    parentSelector,
    get('entities')
);
